import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const TRANSPARENCY_EXPLANATIONS = [
  {
    title: "Survival Days",
    body: "We look at your current cash and divide it by your daily running costs. It tells you how long your shop stays open if no more money comes in today.",
  },
  {
    title: "Dead Stock Value",
    body: "We identify items that haven't sold in 30 days and multiply them by what you paid for them. This is cash that is \"stuck\" on your shelves.",
  },
  {
    title: "BI Analyst",
    body: "Our AI looks at your sales velocity and profit margins to find patterns you might miss, helping you make better buying decisions.",
  },
];

interface TransparencyModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function TransparencyModal({ open, onOpenChange }: TransparencyModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="transparency-modal" className="max-w-md sm:max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>How did we calculate this?</DialogTitle>
        </DialogHeader>
        <div data-testid="transparency-modal-content" className="space-y-6 pt-2">
          {TRANSPARENCY_EXPLANATIONS.map((item) => (
            <div key={item.title}>
              <h3 className="text-sm font-semibold text-foreground mb-1.5">{item.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{item.body}</p>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
